import React from "react";
import { Brain, Cloud, MapPin } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const features = [{
  title: "Regional Expertise",
  description: "Deeply rooted in Nairobi, we understand the unique challenges and opportunities within the Kenyan and East African markets.",
  icon: MapPin
}, {
  title: "AI & Cloud Mastery",
  description: "We deliver end-to-end customized AI and cloud solutions that drive digital transformation and operational efficiency.",
  icon: Cloud
}, {
  title: "Collaborative Innovation",
  description: "Our partnership approach ensures we build sustainable solutions together, fostering growth for startups and enterprises alike.",
  icon: Brain
}];
export default function WhyChooseInaraTechnologies() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="why-choose-inara-technologies" ref={ref} className="relative w-full py-24 overflow-hidden bg-background">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none">
        <div className="absolute top-20 left-20 w-96 h-96 bg-[var(--chart-1)]/10 rounded-full blur-3xl opacity-50" />
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-[var(--chart-2)]/10 rounded-full blur-3xl opacity-50" />
      </div>

      <div className="container relative mx-auto px-4 md:px-6 z-10">
        <div className={cn("text-center max-w-3xl mx-auto mb-16 transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4 text-foreground font-sans">
            Why Choose Inara Technologies?
          </h2>
          <p className="text-lg text-muted-foreground">
            We combine local insight with global-standard technology to empower businesses across Kenya and the region.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => <div key={index} data-index={index} className={cn("transition-all duration-700 ease-out delay-[var(--delay)]", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")} style={{
          "--delay": `${index * 150}ms`
        } as React.CSSProperties}>
              <Card className="group relative h-full border border-white/10 bg-background/60 backdrop-blur-md shadow-lg transition-all duration-300 hover:-translate-y-2.5 hover:shadow-xl overflow-hidden">
                {}
                <div className="absolute inset-0 bg-gradient-to-br from-[var(--chart-1)]/5 to-[var(--chart-2)]/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                
                <CardHeader className="relative z-10 pb-2">
                  <div className="mb-6 inline-flex items-center justify-center w-12 h-12 rounded-lg bg-secondary/50 backdrop-blur-sm border border-white/5 group-hover:border-[var(--chart-2)]/30 transition-colors duration-300">
                    <feature.icon className="w-6 h-6 text-[var(--chart-1)] transition-colors duration-300 group-hover:text-[var(--chart-2)]" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="text-2xl font-sans font-semibold text-foreground">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                
                <CardContent className="relative z-10">
                  <CardDescription className="text-base text-muted-foreground/80 leading-relaxed">
                    {feature.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}